import React, { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("simo_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("simo_token");
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("simo_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("simo_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const verifyEmail = async (code) => {
    await api.post("/auth/verify-email", { code });
    setUser((u) => (u ? { ...u, email_verified: true } : u));
  };
  const resendVerification = () => api.post("/auth/resend-verification");
  const applyToken = async (token) => {
    localStorage.setItem("simo_token", token);
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };
  const refresh = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };
  const logout = () => { localStorage.removeItem("simo_token"); setUser(null); };

  return <AuthContext.Provider value={{ user, loading, login, register, verifyEmail, resendVerification, applyToken, refresh, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
